import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { getLatestMovies } from "@/utils/movies";

export default function LatestSection() {
  const latest = getLatestMovies(8);

  return (
    <section className="px-4 md:px-10 py-6 md:py-10">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="最新更新"
          subtitle="按更新时间排序，随时掌握剧集动向"
          moreTo="/category?sort=update"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {latest.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}